/* eslint-disable no-unused-vars */
import { axiosApiInstance } from '@/api/axios'

const urlBase = '/api/public'

const state = {
  dataForAboutMenuItem: {},
  dataForAboutMenuItemLoading: false
}

const getters = {
  dataForAboutMenuItem: (state) => state.dataForAboutMenuItem,
  dataForAboutMenuItemLoading: (state) => state.dataForAboutMenuItemLoading
}

const mutations = {
  SET_DATA_FOR_ABOUT_MENU_ITEM(state, payload) {
    state.dataForAboutMenuItem = payload
  },
  SET_DATA_FOR_ABOUT_MENU_ITEM_LOADING(state, payload) {
    state.dataForAboutMenuItemLoading = payload
  }
}

const actions = {
  fetchDataForAboutMenuItem({ commit }, { id }) {
    commit('SET_DATA_FOR_ABOUT_MENU_ITEM_LOADING', true)
    axiosApiInstance
      .get(`${urlBase}/get_single_page`, {
        params: {
          id
        }
      })
      .then((res) => {
        commit('SET_DATA_FOR_ABOUT_MENU_ITEM', res.data)
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          commit('SET_DATA_FOR_ABOUT_MENU_ITEM_LOADING', false)
        }, 500)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
